/// <amd-module name="TFS/Admin/Views/AdminRoles/Redux/AdminRolesModule" />
import { AnyAction, ReducersMapObject } from "redux";
import { ISagaModule } from "redux-dynamic-modules-saga";
import { IAdminRolesAwareState } from "TFS/Admin/Views/AdminRoles/Contracts";
import { adminRolesReducer } from "TFS/Admin/Views/AdminRoles/Redux/AdminRolesReducers";
import { adminRolesSaga } from "TFS/Admin/Views/AdminRoles/Redux/AdminRolesSaga";

export function getAdminRolesModule(): ISagaModule<IAdminRolesAwareState> {
    const reducerMap: ReducersMapObject<IAdminRolesAwareState, AnyAction> = {
        adminRolesState: adminRolesReducer
    };

    return {
        id: "adminRolesState",
        reducerMap,
        sagas: [adminRolesSaga]
    };
}
